export default __webpack_public_path__ + "static/assets/234e09c14ef1600eb376f7720b44cd8c.svg";